import { render } from "./SportsStore.vue?vue&type=template&id=2c4e0425"
import script from "./SportsStore.vue?vue&type=script&lang=js"
export * from "./SportsStore.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__